module.exports = __webpack_public_path__ + "static/media/noodlesSaucesBestOffers.05b6133c.webp";